import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Text } from '@components/Text';
import { useAppSelector } from 'src/hooks';
import { getSelectedSiteDataSelector } from 'src/redesign/features/SelectedSite/store/selectors';
import { selectSettings } from 'src/features/settings-slice';
import S from './TrialUsageBanner.module.scss';

const BANNER_THRESHOLD = 70; // Show banner at 70% usage

export const TrialUsageBanner: FC = () => {
  const selectedSite = useAppSelector(getSelectedSiteDataSelector);
  const settings = useAppSelector(selectSettings);
  const history = useHistory();

  // Don't show if no selectedSite or settings
  if (!selectedSite || !settings) return null;

  // Only show for trial users
  if (settings.plan !== 'trial') return null;

  // Check if at or above threshold
  const percentageUsed = selectedSite.trial_percentage_used || 0;
  if (percentageUsed < BANNER_THRESHOLD) return null;

  // Don't show if already at limit (TrialEndedBanner will handle this)
  const orderCount = selectedSite.trial_order_count || 0;
  const orderLimit = selectedSite.trial_order_limit || 10;
  const attendeeLimitReached = orderCount >= orderLimit;

  // Don't show if trial days have ended (TrialEndedBanner will handle this)
  const trialDaysEnded =
    selectedSite.trial_days_left !== undefined && selectedSite.trial_days_left <= 0;

  // Don't show if trial ended OR attendee limit reached (100% scenario)
  if (attendeeLimitReached || trialDaysEnded) return null;

  const handleUpgradeClick = () => {
    history.push('/events/billing');
  };

  return (
    <div className={S.banner}>
      <div className={S.content}>
        <Text className={S.text}>
          ⚠️ You're close to your trial limit ({orderCount}/{orderLimit} orders).{' '}
          <button onClick={handleUpgradeClick} className={S.upgradeLink}>
            Upgrade to avoid interruptions
          </button>
        </Text>
      </div>
    </div>
  );
};
